import React from 'react';
import { Link } from 'react-router-dom';
import { FotosImovel, Imovel } from '../../data/Imovel';
import { FotoUpload } from './ImovelForm';

interface ImovelFotosFormProps {
  imovel: Partial<Imovel>;
  selectedFiles: FotoUpload[];
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleRemoveNewFile: (file: FotoUpload) => void;
  handleNewFileMetaChange: (index: number, field: 'nome' | 'descricao', value: string) => void;
  handleRemoveExistingFile: (fotoId: number) => void;
  handleEditExistingFile: (foto: FotosImovel) => void;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
  loading: boolean;
  imovelId?: number | string;
}

const ImovelFotosForm: React.FC<ImovelFotosFormProps> = ({
  imovel,
  selectedFiles,
  handleFileChange,
  handleNewFileMetaChange,
  handleRemoveExistingFile,  
  handleEditExistingFile,
  handleRemoveNewFile,
  handleSubmit,
  loading,
  imovelId,
}) => {
  return (
    <form id="frmFotosImovel" onSubmit={handleSubmit}>
      
      <div className="mb-3">
        <label htmlFor="fotos" className="form-label">Selecione uma ou mais fotos para adicionar</label>
        <input type="file" id="fotos" name="fotos" className="form-control" onChange={handleFileChange} multiple accept="image/*" />
      </div>

      {selectedFiles.length > 0 && (
        <div>
          <h6>Pré-visualização das novas fotos:</h6>
          <div className="d-flex flex-wrap gap-3">
            {selectedFiles.map((fotoUpload, index) => (
              <div key={index} className="card" style={{ width: '250px' }}>
                <div className="position-relative">
                  <img src={URL.createObjectURL(fotoUpload.arquivo)} alt="preview" className="card-img-top" style={{ height: '150px', objectFit: 'cover' }} />
                  <button type="button" className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1" onClick={() => handleRemoveNewFile(fotoUpload)}>&times;</button>
                </div>
                <div className="card-body p-2">                  
                  <div>
                    <label htmlFor={`foto-desc-${index}`} className="form-label form-label-sm">Descrição</label>
                    <input type="text" id={`foto-desc-${index}`} className="form-control form-control-sm" value={fotoUpload.descricao} onChange={(e) => handleNewFileMetaChange(index, 'descricao', e.target.value)} />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <hr />
        </div>
      )}

      <h5>Fotos Existentes</h5>
      {imovel.fotos && imovel.fotos.length > 0 ? (
        <div className="d-flex flex-wrap gap-3">
          {imovel.fotos.map(foto => (
            <div key={foto.id} className="card" style={{ width: '250px' }}>
                <div className="position-relative">
                    <img src={foto.url} alt={foto.descricao || 'Foto do imóvel'} className="card-img-top" style={{ height: '150px', objectFit: 'cover' }} />                    
                </div>
                <div className="card-body p-2">
                    <p className="card-text small text-truncate mb-2" title={foto.descricao}>{`${foto.descricao || 'Sem descrição'}${foto.destaque ? ' (Destaque)' : ''}`}</p>
                    <div className="d-flex gap-2">
                        <button type="button" className="btn btn-sm btn-outline-primary w-100" onClick={() => handleEditExistingFile(foto)} disabled={loading}>Editar</button>
                        <button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => foto.id && handleRemoveExistingFile(foto.id)} disabled={loading}>Excluir</button>
                    </div>
                </div>
            </div>            
          ))}
        </div>
      ) : (
        <p>Nenhuma foto cadastrada para este imóvel.</p>
      )}
      <hr />
      <div className="mt-3">
        <button type="submit" className="btn btn-primary" disabled={loading || !imovelId || selectedFiles.length === 0}>
          {loading ? 'Enviando...' : 'Enviar Novas Fotos'}
        </button>
        <Link to="/imoveis" className="btn btn-secondary ms-2">Concluir</Link>
      </div>
    </form>
  );
};

export default ImovelFotosForm;